var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacantFilterFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3596_10238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#62BA60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8296 19.3965V20.9692H8.36719V19.3965H27.8289H27.8296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37891 18.8788C8.39922 18.6845 8.44202 18.5015 8.51094 18.3249C8.77791 17.641 9.24655 17.1266 9.96112 16.8228C10.2252 16.7105 10.5052 16.6582 10.7947 16.6582C14.4386 16.6582 18.0818 16.6582 21.7258 16.6582C22.1182 16.6582 22.4099 16.9295 22.4106 17.2962C22.4113 17.8013 22.4106 18.3058 22.4106 18.8109C22.4106 18.8328 22.4084 18.8547 22.407 18.8788H8.37891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1982 17.3784C29.1982 19.286 29.1982 21.1943 29.1982 23.1019C29.1982 23.1527 29.1975 23.2057 29.1858 23.2545C29.138 23.4544 28.9523 23.5809 28.739 23.5625C28.53 23.5448 28.3741 23.3831 28.3603 23.169C28.3588 23.1492 28.3596 23.1287 28.3596 23.1089C28.3596 19.2846 28.3596 15.4595 28.3596 11.6352C28.3596 11.402 28.4764 11.2417 28.6809 11.1936C28.9377 11.1329 29.1837 11.3102 29.1975 11.5674C29.1989 11.5942 29.1989 11.6211 29.1989 11.6479C29.1989 13.5583 29.1989 15.468 29.1989 17.3784H29.1982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00084 19.1229C7.00084 17.789 7.00084 16.4558 7.00084 15.1219C7.00084 14.8916 7.14593 14.7234 7.36357 14.6959C7.61095 14.6655 7.8235 14.8379 7.83656 15.0809C7.83729 15.0986 7.83656 15.1169 7.83656 15.1346C7.83656 17.7996 7.83656 20.4645 7.83656 23.1295C7.83656 23.3033 7.77055 23.4396 7.6095 23.5202C7.46005 23.5944 7.31134 23.5831 7.1735 23.4898C7.06758 23.4184 7.011 23.316 7.00157 23.1902C6.99939 23.1634 7.00012 23.1365 7.00012 23.1097C7.00012 21.7807 7.00012 20.4511 7.00012 19.1221L7.00084 19.1229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4102 18.8754V18.0283H27.8286V18.8754H22.4102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8931 17.7117H23.9766C23.9968 17.3604 23.9342 17.011 24.052 16.67C24.2325 16.1478 24.7157 15.7666 25.2588 15.7591C26.1258 15.7479 26.9929 15.7554 27.8609 15.7554C27.8692 15.7554 27.8775 15.7582 27.8941 15.761V17.7107L27.8931 17.7117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1053 4C20.9881 4.00107 23.3238 6.34497 23.3216 9.23512C23.3195 12.1156 20.971 14.4509 18.0817 14.4466C15.2032 14.4434 12.8707 12.092 12.875 9.20078C12.8793 6.33209 15.2257 3.99893 18.1053 4ZM15.334 8.3626C15.3158 8.37655 15.2922 8.38943 15.2729 8.40768C15.0175 8.66203 14.7643 8.91853 14.5079 9.17073C14.4157 9.26195 14.4854 9.31132 14.5433 9.36927C15.3791 10.2053 16.217 11.0413 17.0507 11.8795C17.129 11.9579 17.1773 11.9707 17.2631 11.8849C18.7265 10.4167 20.192 8.95072 21.6608 7.48686C21.7509 7.39779 21.7488 7.34198 21.6587 7.25719C21.4377 7.04577 21.2156 6.83435 21.0107 6.6079C20.8894 6.47375 20.8208 6.47697 20.692 6.60683C19.5633 7.74658 18.425 8.87667 17.2953 10.0153C17.1891 10.1227 17.1322 10.1291 17.0238 10.0175C16.5153 9.49699 15.9982 8.98614 15.4832 8.47207C15.4413 8.43021 15.407 8.37441 15.334 8.3626Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3596_10238",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3596_10238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3596_10238",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacantFilterFill);
export default __webpack_public_path__ + "static/media/vacant_filter_fill.8ad8ce747622acfb3ddbbce3e4063c6c.svg";
export { ForwardRef as ReactComponent };